module.exports = __webpack_public_path__ + "static/media/journal.25b2541b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/journal.png
// module id = 41
// module chunks = 0